<!--
@component
Chip labelling a feature as Internal, Alpha, or Beta.

@use-instead-of hand-picked Chip variants for maturity labels
@see Chip
-->
<script lang="ts">
  import Chip from "./Chip.svelte";

  export type FeatureMaturity = "internal" | "alpha" | "beta";

  interface Props {
    maturity: FeatureMaturity;
  }

  let { maturity }: Props = $props();
</script>

{#if maturity === "internal"}
  <Chip variant="warning">Internal</Chip>
{:else if maturity === "alpha"}
  <Chip variant="accent-pink">Alpha</Chip>
{:else if maturity === "beta"}
  <Chip variant="accent-blue">Beta</Chip>
{/if}
